export const handleError = (error) => {
    return (error === null || error === void 0 ? void 0 : error.error) || error;
};
export function handleContractError(error, req) {
    var _a, _b, _c, _d, _e;
    if (typeof error === 'string')
        return { message: error };
    if (error === null || error === void 0 ? void 0 : error.message)
        return error;
    if (error === null || error === void 0 ? void 0 : error.Error) {
        return {
            message: error.Error.Details || error.Error.Message || error.Error,
            code: error.Error.Code,
        };
    }
    return {
        code: ((_b = (_a = req === null || req === void 0 ? void 0 : req.error) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.Code) || (req === null || req === void 0 ? void 0 : req.error),
        message: ((_c = req === null || req === void 0 ? void 0 : req.errorMessage) === null || _c === void 0 ? void 0 : _c.message) || ((_e = (_d = req === null || req === void 0 ? void 0 : req.error) === null || _d === void 0 ? void 0 : _d.message) === null || _e === void 0 ? void 0 : _e.Message),
    };
}
export const handleContractErrorMessage = (error) => {
    if (typeof error === 'string')
        return error;
    if (error === null || error === void 0 ? void 0 : error.message)
        return error.message;
    if (error === null || error === void 0 ? void 0 : error.Error) {
        return error.Error.Details || error.Error.Message || error.Error;
    }
    return `Transaction: ${(error === null || error === void 0 ? void 0 : error.Status) || 'error'}`;
};
export const handleErrorMessage = (error, errorText) => {
    if ((error === null || error === void 0 ? void 0 : error.status) === 500) {
        return errorText || 'Failed to fetch data';
    }
    error = handleError(error);
    error = handleContractError(error);
    if (typeof error.message === 'string')
        errorText = error.message;
    return errorText || '';
};
export const isHtmlError = (code, message) => {
    var _a;
    if (((_a = String(code)) === null || _a === void 0 ? void 0 : _a.substring(0, 1)) === '5' && message.includes('<!DOCTYPE HTML PUBLIC')) {
        return true;
    }
    return false;
};
export const isAuthTokenError = (error) => {
    const msg = handleErrorMessage(error);
    if (msg.includes('401')) {
        return true;
    }
    return false;
};
export const isWriteOperationError = (code, message) => {
    var _a;
    if (((_a = String(code)) === null || _a === void 0 ? void 0 : _a.substring(0, 1)) === '5' && message.includes('A write operation resulted in an error')) {
        return true;
    }
    return false;
};
export const handleWebLoginErrorMessage = (error, errorText) => {
    if (error.nativeError && error.nativeError.message) {
        error = error.nativeError;
    }
    return handleErrorMessage(error, errorText);
};
